import "./frontend.5e8f58f8.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5384"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5384"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bAzgq", function(module, exports) {

$parcel$export(module.exports, "MapContainer", function () { return $86fe693208f2b43f$export$23f3dfd47374502b; });

var $athwO = parcelRequire("athwO");

var $bjwWZ = parcelRequire("bjwWZ");

var $bh6RR = parcelRequire("bh6RR");
function $86fe693208f2b43f$var$_extends() {
    $86fe693208f2b43f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $86fe693208f2b43f$var$_extends.apply(this, arguments);
}
function $86fe693208f2b43f$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $bh6RR.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $bh6RR.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $bjwWZ.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $athwO.createLeafletContext)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $athwO.LeafletProvider), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", $86fe693208f2b43f$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $86fe693208f2b43f$export$23f3dfd47374502b = /*#__PURE__*/ (0, $bh6RR.forwardRef)($86fe693208f2b43f$var$MapContainerComponent);

});
parcelRegister("athwO", function(module, exports) {

$parcel$export(module.exports, "createLeafletContext", function () { return $79fa358b5767e767$export$fb237fa819e17281; });
$parcel$export(module.exports, "extendContext", function () { return $79fa358b5767e767$export$9efaf186a2224858; });
$parcel$export(module.exports, "LeafletProvider", function () { return $79fa358b5767e767$export$a24c9fc2f87814b2; });
$parcel$export(module.exports, "useLeafletContext", function () { return $79fa358b5767e767$export$ea59151b8430a4e9; });

var $bh6RR = parcelRequire("bh6RR");
const $79fa358b5767e767$export$b8efcc4bff45e15b = 1;
function $79fa358b5767e767$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $79fa358b5767e767$export$b8efcc4bff45e15b,
        map: map
    });
}
function $79fa358b5767e767$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $79fa358b5767e767$export$7de1b54b0142048f = (0, $bh6RR.createContext)(null);
const $79fa358b5767e767$export$a24c9fc2f87814b2 = $79fa358b5767e767$export$7de1b54b0142048f.Provider;
function $79fa358b5767e767$export$ea59151b8430a4e9() {
    const context = (0, $bh6RR.useContext)($79fa358b5767e767$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}

});


parcelRegister("8FouT", function(module, exports) {

$parcel$export(module.exports, "Marker", function () { return $64f527b2e5e4ff25$export$e98856a975cab58e; });

var $glDE6 = parcelRequire("glDE6");
var $4dci8 = parcelRequire("4dci8");
var $athwO = parcelRequire("athwO");

var $bjwWZ = parcelRequire("bjwWZ");
const $64f527b2e5e4ff25$export$e98856a975cab58e = (0, $4dci8.createLayerComponent)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $bjwWZ.Marker)(position, options);
    return (0, $glDE6.createElementObject)(marker, (0, $athwO.extendContext)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

});
parcelRegister("glDE6", function(module, exports) {

$parcel$export(module.exports, "createElementObject", function () { return $be6d5c56bb9d176b$export$a080ff44e8067a44; });
$parcel$export(module.exports, "createElementHook", function () { return $be6d5c56bb9d176b$export$2e66ec8a7fb1892f; });

var $bh6RR = parcelRequire("bh6RR");
function $be6d5c56bb9d176b$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $be6d5c56bb9d176b$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $bh6RR.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $bh6RR.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $bh6RR.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $bh6RR.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

});

parcelRegister("4dci8", function(module, exports) {

$parcel$export(module.exports, "createLayerComponent", function () { return $3111e924ce0819bd$export$8a4d5778bce4c3ac; });
$parcel$export(module.exports, "createTileLayerComponent", function () { return $3111e924ce0819bd$export$4f432c6de5c4ddb8; });

var $gmhTX = parcelRequire("gmhTX");

var $5Dg6q = parcelRequire("5Dg6q");

var $glDE6 = parcelRequire("glDE6");

var $a7OFF = parcelRequire("a7OFF");

var $dCUxY = parcelRequire("dCUxY");

var $kw9Jq = parcelRequire("kw9Jq");
function $3111e924ce0819bd$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $glDE6.createElementObject)(createInstance(props), context);
    }
    const useElement = (0, $glDE6.createElementHook)(createElement);
    const useControl = (0, $5Dg6q.createControlHook)(useElement);
    return (0, $gmhTX.createLeafComponent)(useControl);
}
function $3111e924ce0819bd$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $glDE6.createElementHook)(createElement, updateElement);
    const useLayer = (0, $a7OFF.createLayerHook)(useElement);
    return (0, $gmhTX.createContainerComponent)(useLayer);
}
function $3111e924ce0819bd$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $glDE6.createElementHook)(createElement);
    const useOverlay = (0, $dCUxY.createDivOverlayHook)(useElement, useLifecycle);
    return (0, $gmhTX.createDivOverlayComponent)(useOverlay);
}
function $3111e924ce0819bd$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $glDE6.createElementHook)(createElement, updateElement);
    const usePath = (0, $kw9Jq.createPathHook)(useElement);
    return (0, $gmhTX.createContainerComponent)(usePath);
}
function $3111e924ce0819bd$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $glDE6.createElementHook)(createElement, updateElement);
    const useLayer = (0, $a7OFF.createLayerHook)(useElement);
    return (0, $gmhTX.createLeafComponent)(useLayer);
}

});
parcelRegister("gmhTX", function(module, exports) {

$parcel$export(module.exports, "createContainerComponent", function () { return $be8c964d1690ac4b$export$96eac748c3f41e82; });
$parcel$export(module.exports, "createDivOverlayComponent", function () { return $be8c964d1690ac4b$export$bc37ddc24ed05446; });
$parcel$export(module.exports, "createLeafComponent", function () { return $be8c964d1690ac4b$export$18af5c7a9e9b3664; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $athwO = parcelRequire("athwO");
function $be8c964d1690ac4b$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $bh6RR.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $athwO.LeafletProvider), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(ContainerComponent);
}
function $be8c964d1690ac4b$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $bh6RR.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $bh6RR.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $bh6RR.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $6afFj.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(OverlayComponent);
}
function $be8c964d1690ac4b$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $bh6RR.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(LeafComponent);
}

});

parcelRegister("5Dg6q", function(module, exports) {

$parcel$export(module.exports, "createControlHook", function () { return $419d15e8465eb60f$export$28d24ab3914549cd; });

var $bh6RR = parcelRequire("bh6RR");

var $athwO = parcelRequire("athwO");
function $419d15e8465eb60f$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $athwO.useLeafletContext)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $bh6RR.useRef)(props.position);
        const { position: position } = props;
        (0, $bh6RR.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $bh6RR.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

});

parcelRegister("a7OFF", function(module, exports) {

$parcel$export(module.exports, "useLayerLifecycle", function () { return $01e6ff6fb6237616$export$cd00a227f8cfb2c2; });
$parcel$export(module.exports, "createLayerHook", function () { return $01e6ff6fb6237616$export$73f852c6a5abdefa; });

var $bh6RR = parcelRequire("bh6RR");

var $kch8F = parcelRequire("kch8F");

var $athwO = parcelRequire("athwO");

var $ktHn0 = parcelRequire("ktHn0");

var $8SeM5 = parcelRequire("8SeM5");
function $01e6ff6fb6237616$export$cd00a227f8cfb2c2(element, context) {
    (0, $bh6RR.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $01e6ff6fb6237616$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $athwO.useLeafletContext)();
        const elementRef = useElement((0, $8SeM5.withPane)(props, context), context);
        (0, $kch8F.useAttribution)(context.map, props.attribution);
        (0, $ktHn0.useEventHandlers)(elementRef.current, props.eventHandlers);
        $01e6ff6fb6237616$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}

});
parcelRegister("kch8F", function(module, exports) {

$parcel$export(module.exports, "useAttribution", function () { return $eb42390b82b26584$export$46b870813daca3d4; });

var $bh6RR = parcelRequire("bh6RR");
function $eb42390b82b26584$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $bh6RR.useRef)(attribution);
    (0, $bh6RR.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

});

parcelRegister("ktHn0", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", function () { return $ee88287e4f268fed$export$8ce912bc34d0dbea; });

var $bh6RR = parcelRequire("bh6RR");
function $ee88287e4f268fed$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

});

parcelRegister("8SeM5", function(module, exports) {

$parcel$export(module.exports, "withPane", function () { return $675ed3ccbefa2f16$export$6ee5d263358f5c0e; });
function $675ed3ccbefa2f16$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}

});


parcelRegister("dCUxY", function(module, exports) {

$parcel$export(module.exports, "createDivOverlayHook", function () { return $9ebab00431e1d78c$export$d5eca53b0accc0e0; });

var $kch8F = parcelRequire("kch8F");

var $athwO = parcelRequire("athwO");

var $ktHn0 = parcelRequire("ktHn0");

var $8SeM5 = parcelRequire("8SeM5");
function $9ebab00431e1d78c$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $athwO.useLeafletContext)();
        const elementRef = useElement((0, $8SeM5.withPane)(props, context), context);
        (0, $kch8F.useAttribution)(context.map, props.attribution);
        (0, $ktHn0.useEventHandlers)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

});

parcelRegister("kw9Jq", function(module, exports) {

$parcel$export(module.exports, "createPathHook", function () { return $eefe584ff25f5605$export$5fea2fe6048fc3db; });

var $bh6RR = parcelRequire("bh6RR");

var $athwO = parcelRequire("athwO");

var $ktHn0 = parcelRequire("ktHn0");

var $a7OFF = parcelRequire("a7OFF");

var $8SeM5 = parcelRequire("8SeM5");
function $eefe584ff25f5605$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $eefe584ff25f5605$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $athwO.useLeafletContext)();
        const elementRef = useElement((0, $8SeM5.withPane)(props, context), context);
        (0, $ktHn0.useEventHandlers)(elementRef.current, props.eventHandlers);
        (0, $a7OFF.useLayerLifecycle)(elementRef.current, context);
        $eefe584ff25f5605$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}

});



parcelRegister("fNS4C", function(module, exports) {

$parcel$export(module.exports, "TileLayer", function () { return $b815608105712a6f$export$f52ee31d61d0b27b; });

var $glDE6 = parcelRequire("glDE6");
var $4dci8 = parcelRequire("4dci8");
var $joLWJ = parcelRequire("joLWJ");
var $8SeM5 = parcelRequire("8SeM5");

var $bjwWZ = parcelRequire("bjwWZ");
const $b815608105712a6f$export$f52ee31d61d0b27b = (0, $4dci8.createTileLayerComponent)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $bjwWZ.TileLayer)(url, (0, $8SeM5.withPane)(options, context));
    return (0, $glDE6.createElementObject)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $joLWJ.updateGridLayer)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});

});
parcelRegister("joLWJ", function(module, exports) {

$parcel$export(module.exports, "updateGridLayer", function () { return $e1f573542502789e$export$b39104a5f1b9296f; });
function $e1f573542502789e$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}

});



var $ih19M = parcelRequire("ih19M");

var $9ATkq = parcelRequire("9ATkq");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bAzgq = parcelRequire("bAzgq");
var $8FouT = parcelRequire("8FouT");
var $fNS4C = parcelRequire("fNS4C");


var $bjwWZ = parcelRequire("bjwWZ");
// Ensure default Leaflet marker assets load correctly under bundlers
delete (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Icon.Default.prototype._getIconUrl;
(0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png'
});
/**
 * UserLocation Component
 * Displays a user's location on an embedded map
 */ const $6d70696d487a9cee$var$UserLocation = ({ config: config, strings: strings })=>{
    const [loading, setLoading] = (0, $bh6RR.useState)(true);
    const [error, setError] = (0, $bh6RR.useState)(null);
    const [location, setLocation] = (0, $bh6RR.useState)(null);
    // Create custom avatar marker icon - must be before conditional returns (hooks rule)
    const customIcon = (0, $bh6RR.useMemo)(()=>{
        if (!location) return new (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Icon.Default();
        const avatarUrl = config.avatarUrl;
        const displayName = config.displayName || strings.userLocation || 'User Location';
        const safeAlt = displayName.replace(/"/g, '&quot;');
        if (!avatarUrl) return (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).icon({
            iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
            iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            shadowSize: [
                41,
                41
            ]
        });
        const iconHtml = `
            <div class="member-marker" data-user-id="${config.userId || ''}">
                <img src="${avatarUrl}" alt="${safeAlt}" class="marker-avatar" 
                     onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNjY2MiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI2ZmZiIvPgo8cGF0aCBkPSJNMzAgMzJjMC01LjUyMy00LjQ3Ny0xMC0xMC0xMHMtMTAgNC40NzctMTAgMTAiIGZpbGw9IiNmZmYiLz4KPC9zdmc+'" />
            </div>
        `;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).divIcon({
            html: iconHtml,
            className: 'custom-member-marker',
            iconSize: [
                40,
                40
            ],
            iconAnchor: [
                20,
                40
            ],
            popupAnchor: [
                0,
                -40
            ]
        });
    }, [
        location,
        config.avatarUrl,
        config.userId,
        config.displayName,
        strings.userLocation
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // If location is provided in config, use it
        if (config.location && config.location.latitude && config.location.longitude) {
            setLocation(config.location);
            setLoading(false);
        } else // Otherwise fetch the location
        fetchUserLocation();
    }, [
        config
    ]);
    const fetchUserLocation = async ()=>{
        try {
            const formData = new FormData();
            formData.append('action', 'gw_bp_get_location');
            formData.append('user_id', config.userId);
            formData.append('nonce', window.gwBpUserLocationAjax?.nonce || '');
            const response = await fetch(window.gwBpUserLocationAjax?.ajaxurl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            });
            const data = await response.json();
            if (data.success && data.data) setLocation(data.data);
            else setError(strings.noLocation || 'No location set');
        } catch (err) {
            console.error('Error fetching user location:', err);
            setError(strings.error || 'An error occurred');
        } finally{
            setLoading(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "gw-bp-user-location-loading",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                children: strings.loading || 'Loading...'
            })
        ]
    });
    if (error || !location || !location.latitude || !location.longitude) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "gw-bp-user-location-empty",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "empty-state",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                    className: "empty-icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                            d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                            cx: "12",
                            cy: "10",
                            r: "3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: error || strings.noLocation || 'No location set'
                })
            ]
        })
    });
    const position = [
        parseFloat(location.latitude),
        parseFloat(location.longitude)
    ];
    const mapHeight = config.height || '400px';
    const zoom = config.zoom || 12;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "gw-bp-user-location-container",
        children: [
            config.showTitle !== false && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "user-location-header",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: config.title || strings.userLocation || 'User Location'
                })
            }),
            location.address && config.showAddress !== false && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "user-location-address",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                        className: "address-icon",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                                cx: "12",
                                cy: "10",
                                r: "3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: location.address
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "user-location-map",
                style: {
                    height: mapHeight
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bAzgq.MapContainer), {
                    center: position,
                    zoom: zoom,
                    style: {
                        height: '100%',
                        width: '100%'
                    },
                    scrollWheelZoom: config.scrollWheelZoom !== false,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $fNS4C.TileLayer), {
                            attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                            referrerPolicy: "strict-origin-when-cross-origin"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8FouT.Marker), {
                            position: position,
                            icon: customIcon
                        })
                    ]
                })
            })
        ]
    });
};
var $6d70696d487a9cee$export$2e2bcd8739ae039 = $6d70696d487a9cee$var$UserLocation;



// Keep track of initialized instances
const $ec96c867d25a2f36$var$initializedInstances = new Set();
// Initialize User Location apps
function $ec96c867d25a2f36$var$initUserLocationApps() {
    // Check if we have user location configurations
    if (typeof window.gwBpUserLocationConfig !== 'undefined') Object.keys(window.gwBpUserLocationConfig).forEach((instanceId)=>{
        // Skip if already initialized
        if ($ec96c867d25a2f36$var$initializedInstances.has(instanceId)) return;
        const container = document.getElementById(instanceId);
        if (container) {
            const config = window.gwBpUserLocationConfig[instanceId];
            const strings = window.gwBpUserLocationAjax?.strings || {};
            const root = (0, $9ATkq.createRoot)(container);
            root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $6d70696d487a9cee$export$2e2bcd8739ae039), {
                config: config,
                strings: strings
            }));
            $ec96c867d25a2f36$var$initializedInstances.add(instanceId);
        }
    });
}
// Wait for DOM to be ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $ec96c867d25a2f36$var$initUserLocationApps);
else $ec96c867d25a2f36$var$initUserLocationApps();
// Also check for late-loaded configurations
if (typeof window !== 'undefined') {
    // Watch for new configurations being added
    let checkCount = 0;
    const checkForNewConfigs = ()=>{
        if (checkCount > 10) return; // Stop after 10 attempts
        if (typeof window.gwBpUserLocationConfig !== 'undefined') $ec96c867d25a2f36$var$initUserLocationApps();
        else {
            checkCount++;
            setTimeout(checkForNewConfigs, 100);
        }
    };
    setTimeout(checkForNewConfigs, 100);
}


//# sourceMappingURL=user-location.6f2c30e6.js.map
